import React from 'react';
import styled from 'styled-components';
import HttpErrorScreen from 'epic-fortnite-react/components/error/HttpErrorScreen';
import LoadScreen from 'epic-fortnite-react/components/loadScreen/LoadScreen';
import {getInitialCmsPageSharedValues, useCmsData, PageData} from 'epic-fortnite-shared-values';
import {Text} from 'epic-fortnite-react';
import useSound from 'use-sound';
import MetaTags from '../../components/common/MetaTags';

const SLUG = 'marketing-ua';

interface MarketingUAData extends PageData {
  bgImg: string;
  heroImg: string;
  subText: string;
  hasAudio: boolean;
  audioFile: string;
  playIcon: string;
  stopIcon: string;
}

const StyledMarketingUAWrapper = styled.div<{bgImg: string}>`
  background: ${({bgImg}) => `url(${bgImg})`} no-repeat center center;
  background-size: cover;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  img {
    width: 80%;
  }
`;

const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledSoundIconContainer = styled.div`
  position: absolute;
  bottom: 100px;
  left: 50px;
`;

const StyledAudioIconContainer = styled.div`
  cursor: pointer;
`;

const MarketingUAView = () => {
  const {pageData, isLoading, error} = useCmsData<MarketingUAData>(SLUG);
  const [play, {stop, isPlaying}] = useSound(pageData.audioFile, {loop: true});

  if (isLoading || !pageData) return <LoadScreen show={true} />;
  if (error) return <HttpErrorScreen statusCode={500} />;

  return (
    <StyledMarketingUAWrapper bgImg={pageData.bgImg}>
      <MetaTags pageModel={pageData} />
      <StyledContentContainer>
        <img src={pageData.heroImg} alt="" />
        <Text align="center" size={'2xl'} color="#AD0A60">
          {pageData.subText}
        </Text>
      </StyledContentContainer>
      {pageData.hasAudio && (
        <StyledSoundIconContainer>
          <StyledAudioIconContainer
            onClick={() => (isPlaying ? stop() : play())}
            className="mute text-center">
            {isPlaying ? (
              <img src={pageData.stopIcon} alt="" />
            ) : (
              <img src={pageData.playIcon} alt="" />
            )}
          </StyledAudioIconContainer>
        </StyledSoundIconContainer>
      )}
    </StyledMarketingUAWrapper>
  );
};

MarketingUAView.getInitialSharedValues = getInitialCmsPageSharedValues(SLUG);

export default MarketingUAView;
